import { ChangeDetectionStrategy, Component } from '@angular/core'

import { Closeable } from '@app/overlays/closeable'
import { UIModule } from '@ui/ui.module'

@Component({
  selector: 'sb-message-photo-album-single-disapproved-modal',
  templateUrl: './message-photo-album-single-disapproved-modal.component.html',
  imports: [UIModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessagePhotoAlbumSingleDisapprovedModalComponent extends Closeable {}
